import React, { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../components/tables/ReportsTable';

const serviceChannels = ['AEPS', 'Recharge', 'Bill Pay', 'UPI', 'Fund Transfer', 'Settlement'];
const statuses = ['Settled', 'Pending', 'Failed'];

const generateLedgerData = (count = 110) => {
  return Array.from({ length: count }, (_, index) => {
    const isCredit = Math.random() > 0.5;
    const creditAmount = isCredit ? parseFloat((Math.random() * 3500 + 250).toFixed(2)) : 0;
    const debitAmount = !isCredit ? parseFloat((Math.random() * 3200 + 250).toFixed(2)) : 0;
    const balance = parseFloat((Math.random() * 125000 + 45000).toFixed(2));

    const ledgerDate = new Date(
      2025,
      Math.floor(Math.random() * 11),
      Math.floor(Math.random() * 28) + 1,
      Math.floor(Math.random() * 24),
      Math.floor(Math.random() * 60)
    );

    const descriptionPrefix = isCredit ? 'Commission' : 'Settlement';

    return {
      id: `DLDG${String(index + 1).padStart(5, '0')}`,
      ledgerDate: ledgerDate.toISOString().split('T')[0],
      ledgerTime: ledgerDate.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }),
      txnType: isCredit ? 'Credit' : 'Debit',
      description: `${descriptionPrefix} ${serviceChannels[Math.floor(Math.random() * serviceChannels.length)]}`,
      referenceId: `REF${Math.random().toString(36).substring(2, 10).toUpperCase()}`,
      credit: creditAmount,
      debit: debitAmount,
      balance,
      channel: serviceChannels[Math.floor(Math.random() * serviceChannels.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      counterparty: isCredit ? 'Master Distributor' : `Retailer ${Math.floor(Math.random() * 180) + 1}`,
    };
  });
};

const formatCurrency = (value) => `₹${Number(value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

const ReportsLedger = () => {
  const [ledgerData] = useState(() => generateLedgerData(130));

  const columns = useMemo(
    () => [
      { key: 'id', label: 'ID' },
      { key: 'ledgerDate', label: 'Ledger Date' },
      { key: 'ledgerTime', label: 'Ledger Time' },
      {
        key: 'txnType',
        label: 'Txn Type',
        render: (row) => (
          <span className={row.txnType === 'Credit' ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
            {row.txnType}
          </span>
        ),
      },
      { key: 'description', label: 'Description' },
      { key: 'referenceId', label: 'Reference ID' },
      {
        key: 'credit',
        label: 'Credit (₹)',
        render: (row, value) => (value ? formatCurrency(value) : '-'),
      },
      {
        key: 'debit',
        label: 'Debit (₹)',
        render: (row, value) => (value ? formatCurrency(value) : '-'),
      },
      {
        key: 'balance',
        label: 'Balance (₹)',
        render: (row, value) => formatCurrency(value),
      },
      { key: 'channel', label: 'Channel' },
      {
        key: 'status',
        label: 'Status',
        render: (row) => {
          const variant = row.status === 'Settled' ? 'success' : row.status === 'Pending' ? 'warning' : 'danger';
          return <span className={`badge bg-${variant}`}>{row.status}</span>;
        },
      },
      { key: 'counterparty', label: 'Counterparty' },
    ],
    []
  );

  return (
    <Container fluid>
      <ReportsTable
        data={ledgerData}
        reportType="Distributor_Ledger"
        columns={columns}
        title="Ledger"
        cellPaddingY={8}
      />
    </Container>
  );
};

export default ReportsLedger;

